import axiosInstance from "../utils/authUtils";
import { API_PATHS } from "../utils/constants/api.constants";

class SosService {
  // Get all SOS alerts
  static async getSosAlerts(params = {}) {
    const response = await axiosInstance.get(
      API_PATHS.getsosalerts,
      { params }
    );

    return response.data;
  }

  // Resolve SOS alert
  static async resolveSos(id, payload = {}) {
    const response = await axiosInstance.put(
      API_PATHS.resolvesos.replace(":id", id),
      payload
    );

    return response.data;
  }

  // Cancel SOS alert
  static async cancelSos(id, payload = {}) {
    const response = await axiosInstance.post(
      API_PATHS.cancelsos.replace(":id", id),
      payload
    );

    return response.data;
  }
}

export default SosService;